import { cn } from '@/lib/cn';
import { NexaGlyph } from './nexa-glyph';
import { NexaWordmark } from './nexa-wordmark';
import './nexa-mark.css';

export interface NexaLockupLightProps {
  /** `hud` — a screen corner; `card` — the head of a dialog; `hero` — a closing title card. */
  size: 'hud' | 'card' | 'hero';
  className?: string;
}

const GLYPH = { hud: 'h-8 w-9', card: 'h-9 w-10', hero: 'h-20 w-[5.5rem] sm:h-24 sm:w-[6.5rem]' } as const;
const WORD = {
  hud: 'h-[15px] w-[86px]',
  card: 'h-[17px] w-[98px]',
  hero: 'h-[30px] w-[172px] sm:h-[38px] sm:w-[218px]',
} as const;

/**
 * The Nexa lockup for DARK, fixed surfaces (the screensaver, the screen lock): the light
 * glyph — white arms, cyan core — beside the NEXA wordmark in white, with a soft cyan
 * halo behind the core so the mark stays luminous on a night sky. The chrome's themed
 * lockup is `NexaLockup`; this one never follows the theme.
 */
export function NexaLockupLight({ size, className }: NexaLockupLightProps) {
  return (
    <span className={cn('nexa-lockup-light', `nexa-lockup-light--${size}`, 'flex items-center text-white', className)}>
      <span className="nexa-lockup-light__glyph relative">
        <NexaGlyph tone="light" className={GLYPH[size]} />
      </span>
      <NexaWordmark className={WORD[size]} />
    </span>
  );
}
